import React, { useEffect } from "react";
import { Navigate, Route, Routes } from "react-router-dom";

// Routes

// JS Files
import { useUserData } from "./context/UserDataContext.js";
import Record from "./components/record/Record.js";
import Homepage from "./components/homepage/Homepage.js";
import Followup from "./components/followup/Followup.js";
import Rules from "./components/rules/Rules.js";
import Notifications from "./components/notifications/Notifications";
import NotificationsDetails from "./components/notifications/NotificationsDetails.js";
import Contactus from "./components/contactus/Contactus.js";
import Aboutus from "./components/aboutus/Aboutus.js";
import Questions from "./components/homepage/Questions.js";
import Centers from "./components/centers/Centers.js";
import SignupTakmili from "./components/darman-takmili/signup/SignupTakmili.js";
import StepOne from "./components/darman-takmili/signup/form/StepOne.js";
import StepTwo from "./components/darman-takmili/signup/form/StepTwo.js";
import StepThree from "./components/darman-takmili/signup/form/StepThree.js";
import FollowupTakmili from "./components/darman-takmili/followup/FollowupTakmili.js";

//................. Admin.............

const Authenticated = () => {
  const { userData } = useUserData();

  return (
    <>
      <Routes>
        <Route path="/" element={<Homepage />} />
        <Route path="*" element={<Navigate to="/" replace />} />
        <Route path="/record/:type" element={<Record />} />
        <Route path="/follow-up/:type" element={<Followup />} />
        <Route path="/rules" element={<Rules />} />
        <Route path="/notifications" element={<Notifications />} />
        <Route
          path="/notifications-details/:id"
          element={<NotificationsDetails />}
        />
        <Route path="/contactus" element={<Contactus />} />
        <Route path="/aboutus" element={<Aboutus />} />
        <Route path="/questions" element={<Questions />} />
        <Route path="/centers/:province/:city" element={<Centers />} />
        <Route path="/darman-takmili-signup" element={<SignupTakmili />} />
        <Route path="/step-one" element={<StepOne />} />
        <Route path="/step-two" element={<StepTwo />} />
        <Route path="/step-three" element={<StepThree />} />
        <Route path="/follow-up-takmili" element={<FollowupTakmili />} />
      </Routes>
      {/* 1 */}
      {/* <Route path="/redirect" element={<Navigate to="/setting-ring"/>}/> */}
      {/* 2 */}
      {/* <Route path="/setting/*" element={<Ring />} />
          in the Ring Component use the nested route like below:
          <Routers>
            <Route path="/nested" element={<Nested />} />
          </Routers> */}
    </>
  );
};
export default Authenticated;
